
import React from 'react';
import styles from './SideBar.module.css';

// external dependencies
import { RxDashboard } from 'react-icons/rx';
import { BsSave2 } from 'react-icons/bs';
import { BiSupport } from 'react-icons/bi';
import { HiOutlineLogout } from 'react-icons/hi';
import { NavLink } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import { RiNotificationBadgeLine } from 'react-icons/ri';
import { useSelector } from 'react-redux';  


const SideBar = ()=>{

        const yesLogOutAndNavigateToLogin =()=>{

            setTimeout(()=>{
                window.location.href = ('http://fanonix.com/login')
                localStorage.removeItem('token');
                alert("You have logged out");
                setTimeout(() => {
                    return null
                }, 500);
            }, 2000)
        };



    const { value } = useSelector(state=> state.app_name);

    const activeStyle = {
        color: '#833AB4',
        fontWeight: 'bolder',
    }

    return(<div className={styles.SideBar_Wrapper}>
        
        <div className={styles.Side_Bar_cont}>

            <ul className={styles.uonrdered_list_for_sidebar}>

                <li className={styles.li_for_sidebar_list}>
                    <NavLink to={'/'} className={styles.anchor_tag_for_SideBar} style={{
                        fontWeight: 'bolder'
                    }}>
                        { value }
                    </NavLink>
                </li>
                

                <li className={styles.li_for_sidebar_list} style={{marginTop:'0.6em'}}>
                    <NavLink to={'/dashboard'} className={styles.anchor_tag_for_SideBar}
                    style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  }
                    >
                        <i><RxDashboard  className={styles.icons_for_sd_bar}/></i>
                        &#160;&#160;
                        Dashboard
                    </NavLink>
                </li>

                <li className={styles.li_for_sidebar_list}>
                    <NavLink to={'/invest'} className={styles.anchor_tag_for_SideBar}
                    style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  }
                    >
                        <BsSave2  className={styles.icons_for_sd_bar}/>
                        &#160;&#160;
                        Invest
                    </NavLink>
                </li>

                <li className={styles.li_for_sidebar_list}>
                    <NavLink to={'/notifications'} className={styles.anchor_tag_for_SideBar}
                    style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  }
                    >
                        <RiNotificationBadgeLine  className={styles.icons_for_sd_bar}/>
                        &#160;&#160;
                        Notifications
                    </NavLink>
                </li>

                

                <li className={styles.li_for_sidebar_list}>
                    <NavLink to={'/support'} className={styles.anchor_tag_for_SideBar}
                    style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  }
                    >
                        <BiSupport className={styles.icons_for_sd_bar}/>
                        &#160;&#160;

                        Support
                    </NavLink>
                </li>

                <li className={styles.li_for_sidebar_list}>
                    <NavLink to={'/settings'} className={styles.anchor_tag_for_SideBar}
                    style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  }
                    >
                        <FiSettings className={styles.icons_for_sd_bar}/>
                        &#160;&#160;

                        Settings
                    </NavLink>
                </li>
            </ul>


        </div>

        <div>

            <ul style={{listStyle: 'none'}}>
                <li style={{cursor: 'pointer'}} className={styles.log_out_session_} onClick={yesLogOutAndNavigateToLogin}>
                   <span className={`${styles.anchor_tag_for_SideBar} ${styles.log_out_anchor}`} 
                //    to={'/log-out'}
                   >
                        <HiOutlineLogout size={18} className={styles.icons_for_sd_bar}/>
                        &#160;&#160;

                        Logout
                   </span>
                </li>
            </ul>
        </div>

    </div>)
}

export default SideBar;